import React, { Suspense } from 'react';
import { Navigate } from "react-router-dom";

import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';
import LazyLoadable from '@helpers/LazyLoadable';
import { lazy } from '@loadable/component';
import { ARCHEM_APPS } from '@src/app/pages/home/ArchemApps';
import ProtectedRoute from '@src/app/routes/ProtectedRoute';

const Dialog = LazyLoadable(lazy(() => import('./purchase-order/dialog/Dialog')));
const SendMail = LazyLoadable(lazy(() => import('./purchase-order/dialog/SendMail')));

const NonRawMats = LazyLoadable(lazy(() => import('./purchase-order/PurchaseOrder')));
const SupplierMaintenance = LazyLoadable(lazy(() => import('./settings/suppliers/SuppliersCard')));
const PaymentTermsCard = LazyLoadable(lazy(() => import('./settings/payments/PaymentsCard')));
const SupplierDialog = LazyLoadable(lazy(() => import('./settings/suppliers/dialog/SupplierDialog')))

export const ROUTES_NON_RAW_MATS = [
  {
    path: "/nonrawmats",
    element: <Suspense fallback={<LoadingSpinner />}> <ProtectedRoute module_name={ARCHEM_APPS.NON_RAW_MATS.module_name} /> </Suspense>,
    children: [
      {
        index: true,
        element: <Navigate to="purchasecontracts" />,
      },
      {
        path: "maintenance/paymenttermsnonraw",
        element: <PaymentTermsCard />,
      },
      {
        path: "maintenance/suppliersnonraw/*",
        element: <SupplierMaintenance />,
        children: [
          {
            path: "new",
            element: <SupplierDialog />
          },
          {
            path: ":supplier_id",
            element: <SupplierDialog />
          }
        ]
      },
      {
        path: "purchasecontracts/*",
        element: <NonRawMats />,
        children: [
          {
            path: ':type_of_order/:uuid/*',
            element: <Dialog />,
            children: [
              {
                path: 'approvedetails',
                element: <SendMail />
              }
            ]
          },

        ]
      },
    ],
  },

];
